import "./ProgressBar.css";

import type { CSSProperties } from "react";
import type { SizeProp } from "../components";

export interface ProgressBarProps {
  size?: Extract<SizeProp, "sm" | "md" | "lg">;
  value: number;
  variant?: "light" | "dark";
}

export function ProgressBar({ size, value, variant }: ProgressBarProps) {
  const parsedValue = Math.min(value * 100, 100);

  const customProperties = {} as CSSProperties;

  if (size === "sm") {
    customProperties["--progress-bar-height"] = "var(--size-1)";
  }

  if (size === "lg") {
    customProperties["--progress-bar-height"] = "var(--size-2)";
  }

  return (
    <div
      className="ProgressBar"
      style={customProperties}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={parsedValue}
      aria-label={`${parsedValue}%`}
    >
      {Boolean(value) && (
        <div
          className="ProgressBar__value"
          style={{ width: `${parsedValue}%` }}
        />
      )}
    </div>
  );
}
